import { resetPassword } from './states';

export const services = {
  resetPassword,
};
